import { object, string } from 'yup'
import { t } from 'ttag'

import { MESSAGE_FIELD, SENDER_FIELD, SUBJECT_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [SENDER_FIELD]: string().required(t`This field cannot be empty.`),
    [SUBJECT_FIELD]: string().required(t`This field cannot be empty.`),
    [MESSAGE_FIELD]: string().required(t`This field cannot be empty.`),
  })
